(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/router.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/router.js');
"use strict";


const _svs$app$ReactRouter = svs.app.ReactRouter,
  PlayerRouter = _svs$app$ReactRouter.PlayerRouter,
  Route = _svs$app$ReactRouter.Route;
const baseUrl = svs.core.data.baseUrl;
const _svs$ticketsOrderHome = svs.ticketsOrderHome,
  OrderHomeRouter = _svs$ticketsOrderHome.OrderHomeRouter,
  SubscriptionRouter = _svs$ticketsOrderHome.SubscriptionRouter;
const Divider = svs.ticketsOrderHome.pages.Divider;
const DIVIDER = svs.ticketsOrderHome.routes.DIVIDER;
const ScrollToTop = svs.ticketsOrderHome.components.ScrollToTop;
const Router = () => React.createElement(PlayerRouter, {
  basename: baseUrl,
  withRouter: true
}, React.createElement(ScrollToTop, null), React.createElement(Route, {
  component: Divider,
  exact: true,
  path: DIVIDER
}), React.createElement(OrderHomeRouter, null), React.createElement(SubscriptionRouter, null));
setGlobal('svs.ticketsOrderHome.router', Router);
const container = document.getElementById('reactContainer');
container && ReactDOM.render(React.createElement(Router, null), container);

 })(window);